import React, { useMemo, useState } from 'react'
import Style from '../productAttribute.module.css'

/**
 * One searchable column of selectable fields. Selection is driven entirely by the
 * `selectedNames` set the parent passes in - the list itself holds no state beyond
 * its own search text.
 */
const FieldPicker = ({ title, placeholder, fields, selectedNames, disabledNames, onSelect }) => {
    const [search, setSearch] = useState('')

    const visibleFields = useMemo(() => {
        const term = search.trim().toLowerCase()
        if (term === '') {
            return fields
        }
        return fields.filter((field) => field.name.toLowerCase().indexOf(term) !== -1)
    }, [fields, search])

    return (
        <div className={Style.picker}>
            <div className={Style.pickerHeader}>
                <span className={Style.pickerTitle}>{title}</span>
                <span className={Style.pickerCount}>{visibleFields.length}</span>
            </div>
            <input
                type="text"
                className={Style.pickerSearch}
                placeholder={placeholder}
                value={search}
                onChange={(event) => setSearch(event.target.value)}
            />
            <ul className={Style.pickerList}>
                {visibleFields.length === 0 ? (
                    <li className={Style.pickerEmpty}>No matching fields</li>
                ) : null}
                {visibleFields.map((field) => {
                    const isSelected = selectedNames.indexOf(field.name) !== -1
                    const isBlocked = disabledNames.indexOf(field.name) !== -1
                    return (
                        <li key={field.name}>
                            <button
                                type="button"
                                className={[
                                    Style.pickerItem,
                                    isSelected ? Style.pickerItemSelected : '',
                                    isBlocked ? Style.pickerItemBlocked : ''
                                ].join(' ').trim()}
                                disabled={isBlocked}
                                title={isBlocked ? 'Incompatible data type for the selected field' : field.name}
                                onClick={() => onSelect(field)}
                            >
                                <span className={Style.pickerItemName}>{field.name}</span>
                                <span className={Style.pickerItemMeta}>
                                    {field.dataType}
                                    {field.isRequired ? <em className={Style.pickerItemRequired}>required</em> : null}
                                </span>
                                {isSelected ? <i className={`uil-check ${Style.pickerItemTick}`} aria-hidden="true" /> : null}
                            </button>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}

export default FieldPicker
